// extracted by mini-css-extract-plugin
export default {"layout-dashboard":"LayoutDashboard_layout-dashboard__sDjdj","content":"LayoutDashboard_content__w4PNi","page-footer":"LayoutDashboard_page-footer__H1S01"};